import { createRouter, createWebHistory } from "vue-router"

import main from "../components/main.vue"
import login from "../components/login.vue"
import logout from "../components/logout.vue"
import register from "../components/register.vue"
import register_form from "../components/register_form.vue"
import register_complete from "../components/register_complete.vue"
import mypage from "../components/mypage.vue"
import manage_partner from "../components/manage_partner.vue"
import unmatched_partner from "../components/unmatched_partner.vue"
import partner_add from "../components/partner_add.vue"
import manage_staff from "../components/manage_staff.vue"
import manage_prosthesis from "../components/manage_prosthesis.vue"
import manage_prosthesis_sub from "../components/manage_prosthesis_sub.vue"
import popup_prosthesis_select from "../components/popup_prosthesis_select.vue"
import popup_prosthesis_print from "../components/popup_prosthesis_print.vue"
import popup_aiorder_doc_print from "../components/popup_aiorder_doc_print.vue"
import aiorder_step1 from "../components/aiorder_step1.vue"
import aiorder_step2 from "../components/aiorder_step2.vue"
import aiorder_view from "../components/aiorder_view.vue"
import aiorder_history from "../components/aiorder_history.vue"
import aiorder_edit from "../components/aiorder_edit.vue"
import aiorder_print from "../components/aiorder_print.vue"
import board from "../components/board.vue"
import board_view from "../components/board_view.vue"
import board_edit from "../components/board_edit.vue"
import board_write from "../components/board_write.vue"
import dentaltalk from "../components/dentaltalk.vue"
import dentaltalk_view from "../components/dentaltalk_view.vue"
import aiorder from "../components/aiorder.vue"
import aiorder_status from "../components/aiorder_status.vue"
import charge from "../components/charge.vue"
import charge_publish from "../components/charge_publish.vue"
import bill from "../components/bill.vue"
import bill_view from "../components/bill_view.vue"
import pay from "../components/pay.vue"
import paybefore from "../components/pay-before.vue"
import print_imgs from "../components/print_imgs.vue"
import lost_idpw from "../components/lost_idpw.vue"
import notFound from "../components/notFound.vue"

import * as globaljs from '@/components/utils/global';

const routes = [
	{ path: '/', name:'Main', component: main },
	{ path: '/login', name:'Login', component: login },
	{ path: '/logout', name:'Logout', component: logout },
	{ path: '/register', name:'Register', component: register },
	{ path: '/register_form/:mb_type', name:'RegisterForm', component: register_form, props: true },
	{ path: '/register_complete', name:'RegisterComplete', component: register_complete },
	{ path: '/mypage', name:'Mypage', component: mypage },
	{ path: '/manage_partner', name:'ManagePartner', component: manage_partner },
	{ path: '/unmatched_partner', name:'UnmatchedPartner', component: unmatched_partner },
	{ path: '/partner_add', name:'ManageAdd', component: partner_add },
	{ path: '/manage_staff', name:'ManageUser', component: manage_staff },
	{ path: '/manage_prosthesis', name:'ManageProsthesis', component: manage_prosthesis },
	{ path: '/manage_prosthesis_sub/:hos_id', name:'ManageProsthesisSub', component: manage_prosthesis_sub, props: true },
	{ path: '/popup_prosthesis_select', name:'PopupProsthesisSelect', component: popup_prosthesis_select },
	{ path: '/popup_prosthesis_print', name:'PopupProsthesisPrint', component: popup_prosthesis_print },
	{ path: '/popup_aiorder_doc_print', name:'PopupAiorderDocPrint', component: popup_aiorder_doc_print }, // file_path는 props를 안씀
	{ path: '/aiorder_step1', name:'AiorderStep1', component: aiorder_step1 },
	{ path: '/aiorder_step2/:other_id', name:'AiorderStep2', component: aiorder_step2, props: true },
	{ path: '/aiorder_view/:id', name:'AiorderView', component: aiorder_view, props: true },
	{ path: '/aiorder_history/:a_id/:id', name:'AiorderHistory', component: aiorder_history, props: true },
	{ path: '/aiorder_edit/:id', name:'AiorderEdit', component: aiorder_edit, props: true },
	{ path: '/aiorder_print/:id', name:'AiorderPrint', component: aiorder_print, props: true },
	{ path: '/board/:type', name:'Board', component: board, props: true },
	{ path: '/board_view/:type/:id', name:'BoardView', component: board_view, props: true }, // props속성 중요
	{ path: '/board_edit/:type/:id', name:'BoardEdit', component: board_edit, props: true }, // props속성 중요
	{ path: '/board_write/:type', name:'BoardWrite', component: board_write, props: true },
	{ path: '/dentaltalk', name:'DentalTalk', component: dentaltalk },
	{ path: '/dentaltalk_view/:other_id', name:'DentalTalkView', component: dentaltalk_view, props: true },
	{ path: '/aiorder', name:'Aiorder', component: aiorder },
	{ path: '/aiorder_status', name:'AiorderStatus', component: aiorder_status },
	{ path: '/charge', name:'Charge', component: charge },
	{ path: '/charge_publish/:ids', name:'ChargePublish', component: charge_publish, props: true },
	{ path: '/bill', name:'Bill', component: bill },
	{ path: '/bill_view/:id', name:'BillView', component: bill_view, props: true },
	{ path: '/pay', name:'Pay', component: pay },
	{ path: '/paybefore', name:'Paybefore', component: paybefore },
	{ path: '/print_imgs/:id', name:'PrintImgs', component: print_imgs, props: true },
	{ path: '/lost_idpw', name:'LostIdpw', component: lost_idpw },
	
	{ path:'/:pathMatch(.*)*', component: notFound }
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes // `routes: routes`의 줄임
})

router.beforeEach((to, from, next) => {
	const publicPages = ['/login', '/logout', '/register', '/register_form', '/register_complete', '/lost_idpw'];

	// admin 경로로 시작하는 경우에는 처리하지 않도록 예외 처리
	if (to.path.startsWith('/admin')) {
		console.log('index router.js - pass admin');
		next();
		return;
	}

	const authRequired = !publicPages.some(page => to.path.startsWith(page)); // 보호된 페이지인지 여부
	const loggedIn = globaljs.safeGetItem('token'); // 로그인 상태 확인

	if (authRequired && !loggedIn) {
		// 로그인하지 않은 상태에서 보호된 페이지에 접근 시
		if (to.path !== '/login') {
			console.debug('router.beforeEach() if-if');
			next('/login'); // 로그인 페이지로 리디렉션
		} else {
			console.debug('router.beforeEach() if-else');
			next(); // 이미 로그인 페이지인 경우 페이지 이동 없이 그대로 유지
		}
	} else if (to.path === '/login' && loggedIn) {
		// 로그인한 상태에서 로그인 페이지로 접근하려 할 때
		console.debug('이미 로그인된 상태에서 로그인 페이지로 이동 시도');
		next('/'); // 이미 로그인된 상태이므로 홈 페이지로 리디렉션
	} else {
		console.debug('로그인 후 mb_level : ', globaljs.safeGetItem('mb_level') ?? 0);
		next(); // 그 외의 경우 페이지 이동 허용
	}
});

export default router;